import { AccountPreferences } from "../components/AccountPreferences";
import { Details } from "../components/Details";
import { Header } from "../components/Header";
import "./ProfileView.scss";

export function ProfileView({ handleLogout }: { handleLogout: () => void }) {
  return (
    <div className="profile-view">
      <Header onClick={handleLogout} btnVisible />
      <Details />
      <AccountPreferences />
    </div>
  );
}
